export const SET_ALL_MEDSERVICES = 'SET_ALL_MEDSERVICES';
export const SET_MEDSERVICE = 'SET_MEDSERVICE';
